import { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { addRequest, fetchPendingRequests } from "../slices/tourRequestSlice";

const SendRequestModal = ({ isOpen, onClose, tour_id }) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    tourId: tour_id
  });

  const dispatch = useDispatch();
  const isSubmitting = useRef(false); // Bir dəfə göndərməyi təmin etmək üçün

  if (!isOpen) return null;

  console.log(tour_id);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (isSubmitting.current) return; // Əgər artıq submit olunubsa, funksiyadan çıx
    isSubmitting.current = true; // Submit prosesini başladırıq

    try {
      await dispatch(addRequest(formData));
      await dispatch(fetchPendingRequests());
      onClose();
    } catch (error) {
      console.error("Sorğu göndərilərkən xəta:", error);
    } finally {
      isSubmitting.current = false; // Proses bitdikdən sonra submiti yenidən aktiv edirik
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-btn" onClick={onClose}>✖</button>
        <h2>Tur üçün sorğu göndər</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Ad"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="phone"
            placeholder="Telefon nömrəsi"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Elektron poçt"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <button type="submit" className="submit-btn">
            Göndər
          </button>
        </form>
      </div>
    </div>
  );
};

export default SendRequestModal;